import React, { useEffect, useState } from 'react';
import { isStandalone } from './pwa';

export default function InstallTools() {
  const [prompt, setPrompt] = useState(null), [installed, setInstalled] = useState(isStandalone);
  const [help, setHelp] = useState(false), [busy, setBusy] = useState(false);
  useEffect(() => {
    const available = event => { event.preventDefault(); setPrompt(event); };
    const complete = () => { setInstalled(true); setPrompt(null); };
    const mode = window.matchMedia?.('(display-mode: standalone)');
    const changed = () => setInstalled(isStandalone());
    window.addEventListener('beforeinstallprompt', available);
    window.addEventListener('appinstalled', complete);
    mode?.addEventListener?.('change', changed);
    return () => {
      window.removeEventListener('beforeinstallprompt', available);
      window.removeEventListener('appinstalled', complete);
      mode?.removeEventListener?.('change', changed);
    };
  }, []);
  async function install() {
    if (!prompt) { setHelp(value => !value); return; }
    setBusy(true);
    try {
      await prompt.prompt();
      await prompt.userChoice;
    } catch {
      setHelp(true);
    } finally { setPrompt(null); setBusy(false); }
  }
  if (installed) return null;
  return <aside className="tools-install" aria-label="Install breck.">
    <div><strong>Your tools, one tap away.</strong><p>Open all your apps from your home screen with breck.</p></div>
    <button type="button" className="button secondary" disabled={busy} onClick={install} aria-expanded={!prompt ? help : undefined} aria-controls={!prompt ? 'tools-install-help' : undefined}>Install breck.</button>
    {help && <div id="tools-install-help" className="tools-install-help">
      <p><strong>iPhone / iPad:</strong> Open Tools in Safari, tap Share, then Add to Home Screen. Enable Open as Web App if shown, then tap Add.</p>
      <p><strong>Android:</strong> Open Tools in Chrome, tap the menu (⋮), then Install app or Add to Home screen, and follow the instructions.</p>
      <p><strong>Desktop:</strong> Use the install icon in your browser's address bar or its app installation menu.</p>
    </div>}
  </aside>;
}
